module.exports = __webpack_public_path__ + "img/headline_bg2.5fcc5c1e.png";